import Cookies from "universal-cookie";
import Api from "../helpers/Api";
import constants from "../shared/constants/environmentConfig";
import { getAccountsDomain } from "../helpers/Utils";
import { showToast } from "./snackBar";
import { UPDATE_STUDENT_DATA } from "../actions";
import _ from "lodash";
const cookies = new Cookies();
const Constants = constants();
export const UPDATE_STUDENT_DETAILS = "institute/UPDATE_STUDENT_DETAILS";
export const UPDATE_FEE_REDUCER_DATA = "Fee/UPDATE_FEE_REDUCER_DATA";
export const ADD_FEE = "Fee/ADD_FEE";
export const UPDATE_FEE_DATA = "Fee/UPDATE_FEE_DATA";
export const UPDATE_HOME_REDUCER = "Fee/UPDATE_HOME_REDUCER";
export const UPDATE_MENU_MODEL = "Fee/UPDATE_MENU_MODEL";
export const UPDATE_FEE_BUNDLE = "Fee/UPDATE_FEE_BUNDLE";
export const UPDATE_FEE = "Fee/UPDATE_FEE";

export const updateFeeReducer = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_FEE_REDUCER_DATA, payload });
};

export const showLoader = (show) => async (dispatch) => {
  await dispatch({
    type: UPDATE_FEE_REDUCER_DATA,
    payload: {
      isLoading: show,
    },
  });
};

export const getMembershipDetails = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: "/institutes/get_membership_details_fb",
  });
  if (response.success) {
    const payload = {
      isLoading: false,
      campuses: response.campuses,
      classrooms: response.classrooms,
      departments: response.departments,
      electives: response.electives,
      courses: response.courses,
      isHigherEducationInstitute: response.is_higher_education_institute,
      institutesTags: response.tags,
      institutesTagGroups: response.tag_groups,
    };
    await dispatch({ type: UPDATE_FEE_REDUCER_DATA, payload });
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { isFinance: response.is_finance },
    });
  }
  await dispatch(showLoader(false));
  return response;
};

export const createNewTag = (name, tagGroup) => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "post",
    url: "/institutes/create_new_institute_tag",
    data: {
      new_tag_name: name,
      tag_group: tagGroup === null ? 0 : tagGroup.value,
    },
  });
  if (response.success) {
    dispatch({
      type: UPDATE_FEE_REDUCER_DATA,
      payload: {
        institutesTags: response.tags,
        institutesTagGroups: response.tag_groups,
      },
    });
  }
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  await dispatch(showLoader(false));
  return response;
};

export const createNewInstitutesTagGroup = (name) => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "post",
    url: "/institutes/create_new_institute_tag_group",
    data: { new_tag_group_name: name },
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_FEE_REDUCER_DATA,
      payload: {
        institutesTags: response.tags,
        institutesTagGroups: response.tag_groups,
      },
    });
  }
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  await dispatch(showLoader(false));
  return response;
};

export function updateCurrentStudentData(
  index,
  studentName,
  badgeId,
  phone,
  studentEmail,
  classroomId,
  classroomName,
  studentCampus,
  active,
  fatherName,
  fatherPhone,
  dob,
  fatherEmail,
  motherName,
  motherPhone,
  motherEmail,
  address,
  bloodGroup,
  doj,
  institutesTagIds,
  isHostelite
) {
  return (dispatch) => {
    const payload = {
      index,
      data: {
        first_name: studentName,
        phone,
        student_id: badgeId,
        classroom_id: classroomId,
        classroom_name: classroomName,
        campus_name: studentCampus,
        email: studentEmail,
        father_name: fatherName,
        father_phone: fatherPhone,
        dob,
        father_email: fatherEmail,
        mother_name: motherName,
        mother_phone: motherPhone,
        mother_email: motherEmail,
        address,
        blood_group: bloodGroup,
        doj,
        active,
        tag_ids: institutesTagIds,
        is_hostelite: isHostelite,
      },
    };
    dispatch({
      type: UPDATE_STUDENT_DETAILS,
      payload,
    });
  };
}

export function updateStudentDetails(
  student,
  studentName,
  badgeId,
  phone,
  studentEmail,
  classroomId,
  courseId,
  active,
  fatherName,
  fatherPhone,
  dob,
  fatherEmail,
  motherName,
  motherPhone,
  motherEmail,
  address,
  bloodGroup,
  doj,
  studentElectives,
  institutesTagIds,
  isHostelite
) {
  const studentElectivesData = studentElectives
    ? JSON.stringify(studentElectives)
    : [];
  return (dispatch) =>
    Api({
      method: "post",
      url: "/institutes/update_student_details",
      data: {
        id: student,
        student_name: studentName,
        badge_id: badgeId,
        phone,
        email: studentEmail,
        classroom_id: classroomId,
        course_id: courseId,
        active,
        father_name: fatherName,
        father_phone: fatherPhone,
        dob,
        father_email: fatherEmail,
        mother_name: motherName,
        mother_phone: motherPhone,
        mother_email: motherEmail,
        address,
        blood_group: bloodGroup,
        doj,
        studentElectives: studentElectivesData,
        tag_ids: JSON.stringify(institutesTagIds),
        is_hostelite: isHostelite,
      },
    }).then((response) => {
      dispatch(showToast(response.message));
      return response;
    });
}

export const getCreatedFeeDetails = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: "/fees/get_fee_details_of_institute",
  });
  let payload = {};
  if (response.success) {
    payload.createdFeeDetails = response.fee_details;
  }
  payload.isLoading = false;
  dispatch({ type: UPDATE_FEE_REDUCER_DATA, payload });
  return response;
};

export const addFeeToBundle = (feeDetails) => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "post",
    url: "/fees/",
    data: {
      fee: JSON.stringify(feeDetails),
    },
  });
  if (response.success) {
    dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: {
        feeDetails: response.fees,
        feeBundles: response.fee_bundles,
      },
    });
  }
  await dispatch(showLoader(false));
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  return response;
};

export const updateFeeDetails = (feeDetails, feeId) => async (dispatch) => {
  await dispatch({
    type: UPDATE_HOME_REDUCER,
    payload: { updateFeeLoader: true },
  });
  const response = await Api({
    method: "post",
    url: "/fees/update",
    data: {
      fee_id: feeId,
      fee: JSON.stringify(feeDetails),
    },
  });
  if (response.success) {
    dispatch({
      type: UPDATE_FEE,
      payload: {
        ...feeDetails,
        feeId,
      },
    });
  }
  await dispatch({
    type: UPDATE_HOME_REDUCER,
    payload: { updateFeeLoader: false },
  });
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  return response;
};

export const getFeeBundles = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    methid: "get",
    url: "/fees/get_bundles",
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: {
        isLoading: false,
        feeBundles: response.fee_bundles,
        feeAccounts: response.fee_accounts,
      },
    });
    return;
  }
  await dispatch(showToast(response.message));
  await dispatch(showLoader(false));
};

export const createFeeBundle = (name, academicYear) => async (dispatch) => {
  const response = await Api({
    method: "post",
    url: "/fees/create_bundle",
    data: { name, academic_year: JSON.stringify(academicYear) },
  });
  if (response.success) {
    dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { feeBundles: response.fee_bundles },
    });
  }
  await dispatch(showToast(response.message));
  return response;
};

export const addFeeNote = (note, id) => async (dispatch) => {
  const response = await Api({
    method: "post",
    url: "/fees/add_note_to_student",
    data: { note, id },
  });
  if (response.success) {
    dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeNotes: [...(response.fee_notes || [])],
      },
    });
  }
};

export const updateFeeBundle =
  (name, feeBundleId, academicYear) => async (dispatch) => {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { feeBundleUpdateLoader: true },
    });
    const response = await Api({
      method: "post",
      url: "/fees/update_bundle",
      data: {
        fee_bundle_id: feeBundleId,
        name,
        academic_year: JSON.stringify(academicYear),
      },
    });
    if (response.success) {
      await dispatch({
        type: UPDATE_FEE_BUNDLE,
        payload: {
          feeBundleId,
          feeBundleName: name,
        },
      });
    }
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { feeBundleUpdateLoader: false },
    });
    if (!!response.message) {
      await dispatch(showToast(response.message));
    }
    return response;
  };

export const toggleFeeBundleStatus =
  (feeBundleId, feeBundleStatus) => async (dispatch) => {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { feeBundleUpdateLoader: true },
    });
    const response = await Api({
      method: "post",
      url: "/fees/toggle_fee_bundle_status",
      data: {
        fee_bundle_id: feeBundleId,
        active: feeBundleStatus,
      },
    });
    if (response.success) {
      await dispatch({
        type: UPDATE_FEE_REDUCER_DATA,
        payload: {
          feeBundles: response.fee_bundles,
        },
      });
    }
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { feeBundleUpdateLoader: false },
    });
    if (!!response.message) {
      await dispatch(showToast(response.message));
    }
    return response;
  };

export const createFeeAccount = (feeAccount) => async (dispatch) => {
  const response = await Api({
    method: "post",
    url: "/fees/create_fee_account",
    data: feeAccount,
  });
  if (response.success) {
    dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: {
        feeBundles: response.fee_bundles,
        feeAccounts: response.fee_accounts,
      },
    });
  }
  await dispatch(showToast(response.message));
  return response;
};

export const updateFeeAccount = (feeAccount) => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "post",
    url: "/fees/update_fee_account",
    data: feeAccount,
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: {
        feeAccounts: response.fee_accounts,
      },
    });
  }
  await dispatch(showLoader(false));
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  return response;
};

export const assignFeeDues =
  (selectedItemsToAssignDue, selectedTypeToAssignDue, selectedFeeBundleId) =>
  async (dispatch) => {
    const response = await Api({
      method: "post",
      url: "/fees/assign_fee_due",
      data: {
        selected_items: JSON.stringify(
          selectedItemsToAssignDue.map((data) => {
            return Number(data);
          })
        ),
        type: selectedTypeToAssignDue,
        fee_bundle_id: selectedFeeBundleId,
      },
    });
    if (response.success) {
      dispatch({
        type: UPDATE_HOME_REDUCER,
        payload: {
          feeBundles: response.fee_bundles,
        },
      });
    }
    dispatch(showToast(response.message));
    return response;
  };

export const getFeesInBundle = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: `/fees/get_fees_in_bundle`,
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: {
        isLoading: false,
        feeDetails: response.fees,
        feeBundles: response.fee_bundles,
        feeAccounts: response.fee_accounts,
      },
    });
     await dispatch({
       type: UPDATE_HOME_REDUCER,
       payload: { isFinance: response.is_finance },
     });
  }
  await dispatch(showLoader(false));
  return response;
};

export const getStudentsData = () => async (dispatch) => {
  const response = await Api({
    method: "get",
    url: `/fees/get_students_data`,
  });
  if (response.success) {
    const payload = {
      campuses: response.campuses,
      classrooms: response.classrooms,
      students: response.student_details,
      institutesTags: response.tags,
      institutesTagGroups: response.tag_groups,
    };
    await dispatch({ type: UPDATE_FEE_REDUCER_DATA, payload });
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { isFinance: response.is_finance },
    });
  }
};

export function logout() {
  Object.keys(cookies.getAll()).forEach((cookieName) => {
    cookies.remove(cookieName, {
      secure: Constants.cookie.secure,
      domain: Constants.cookie.domainRegex,
    });
    cookies.remove(cookieName, { path: "/", secure: Constants.cookie.secure });
  });
  window.location.replace(`${getAccountsDomain()}/logout`);
}

export const updateMenuModel = () => async (dispatch) => {
  await dispatch({ type: UPDATE_MENU_MODEL });
};

export const getDashboardData = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: "/fees/get_dashboard_data",
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: {
        dashboardData: response.dashboard_data,
        studentsList: response.students_list,
        monthly_payment_data: response.monthly_payment_data,
        feesForClassrooms: response.fees_for_classrooms,
        paymentsForClassrooms: response.payments_for_classrooms,
        isAdmin: response.is_admin,
        isFinanceAdmin: response.is_finance_admin,
        isFinance: response.is_finance,
        isLocked: response.is_locked,
        tagsData: response.tags_data,
      },
    });
    await dispatch({
      type: UPDATE_FEE_REDUCER_DATA,
      payload: { campuses: response.campuses, classrooms: response.classrooms },
    });
  } else {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { isLocked: response.is_locked },
    });
  }
  await dispatch(showLoader(false));
  if (!!response.message) {
    await dispatch(showToast(response.message));
  }
  return response;
};

export const getGSTMonthWise = (month) => async (dispatch) => {
  if (!month) {
    await dispatch(showToast("Please Select Month"));
    return;
  }
  const [year, mon] = month.split("-");
  await dispatch(showLoader(true));
  const response = await Api({
    method: "get",
    url: `/fees/get_gst_monthwise?month=${mon}&year=${year}`,
  });
  await dispatch({
    type: UPDATE_HOME_REDUCER,
    payload: { gstDetails: response.payments, isLoading: false },
  });
};

export const getUnAssignedActiveFeeBundles =
  (studentId) => async (dispatch) => {
    const response = await Api({
      method: "get",
      url: `/fees/get_unassigned_active_fee_bundles?student_id=${studentId}`,
    });
    if (response.success) {
      await dispatch({
        type: UPDATE_STUDENT_DATA,
        payload: { unAssignedFeeBundles: response.fee_bundles },
      });
    }
  };

export const getAssignedFeeBundles = (studentId) => async (dispatch) => {
  const response = await Api({
    method: "get",
    url: `/fees/get_assigned_fee_bundles?student_id=${studentId}`,
  });
  await dispatch({
    type: UPDATE_STUDENT_DATA,
    payload: { assignedFeeBundles: response.fee_bundles },
  });
};

export const removeFeeBundle = (feeBundleId, studentId) => async (dispatch) => {
  await dispatch({
    type: UPDATE_STUDENT_DATA,
    payload: {
      isLoading: true,
    },
  });
  const response = await Api({
    method: "post",
    url: "/fees/remove_fee_bundle",
    data: {
      feeBundleId,
      studentId,
    },
  });
  if (response.success) {
    showToast("Fee Bundle removed successfully!");
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        feeDues: response.fee_dues,
        feePaid: _.sortBy(response.fee_paid, ["payment_id"], ["asc"]),
        totalFee: response.total_fee,
        unallocatedAmount: response.unallocated_amount,
      },
    });
  } else {
    showToast("Something went wrong");
  }
  await dispatch({
    type: UPDATE_STUDENT_DATA,
    payload: {
      isLoading: false,
    },
  });
  return response;
};

export const getFeeBundleDetails =
  (feeBundleId, oldFeeBundleId, studentId) => async (dispatch) => {
    const response = await Api({
      method: "get",
      url: `/fees/get_fee_bundle_details?fee_bundle_id=${feeBundleId}&old_fee_bundle_id=${oldFeeBundleId}&student_id=${studentId}`,
    });
    if (response.success) {
      dispatch({
        type: UPDATE_STUDENT_DATA,
        payload: {
          feeBundleDetails: response.fee_details,
          unallocatedAmount: response.unallocated_amount,
        },
      });
    }
  };

export const replaceFeeBundle =
  (feeBundleDetails, oldFeeBundle, studentId) => async (dispatch) => {
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        isLoading: true,
      },
    });
    const response = await Api({
      method: "post",
      url: `/fees/replace_fee_bundle`,
      data: {
        fee_bundle_details: JSON.stringify(feeBundleDetails),
        old_fee_bundle: JSON.stringify(oldFeeBundle),
        student_id: studentId,
      },
    });
    if (response.success) {
      showToast(response.message);
      await dispatch({
        type: UPDATE_STUDENT_DATA,
        payload: {
          feeDues: response.fee_dues,
          feePaid: _.sortBy(response.fee_paid, ["payment_id"], ["asc"]),
          totalFee: response.total_fee,
          unallocatedAmount: response.unallocated_amount,
          feeBundleDetails: [],
        },
      });
    } else {
      showToast("Something went wrong!");
    }
    await dispatch(getAssignedFeeBundles(studentId));
    await dispatch(getUnAssignedActiveFeeBundles(studentId));
    await dispatch({
      type: UPDATE_STUDENT_DATA,
      payload: {
        isLoading: false,
      },
    });
    return response;
  };

export const newLeadData =
  (name, email, phone, organizationName, product) => async () => {
    const response = await Api({
      method: "post",
      url: "/add_leads",
      data: {
        phone,
        product,
        organizationName,
        name,
        email,
      },
    });
    if (!response.success) {
      showToast("Something went wrong");
    }
    return response;
  };

export const lockOrUnlockInstitute = () => async (dispatch) => {
  await dispatch(showLoader(true));
  const response = await Api({
    method: "post",
    url: "/fees/lock_or_unlock_institute",
  });
  if (response.success) {
    await dispatch({
      type: UPDATE_HOME_REDUCER,
      payload: { isLocked: response.is_locked },
    });
    await dispatch(showToast("Toggled Successfully"));
  } else {
    await dispatch(showToast("Something Went wrong! Try again later"));
  }
  await dispatch(showLoader(false));
};

export const sendFeeReminder =
  (studentId, studentBalance) => async (dispatch) => {
    const response = await Api({
      method: "post",
      url: "/fees/send_fee_reminder",
      data: { student_id: studentId, student_balance: studentBalance },
    });
    if (!!response.message) {
      await dispatch(showToast(response.message));
    }
    return response;
  };
